import { Helmet } from 'react-helmet-async';
import { organizationSchema, websiteSchema } from '../utils/schema';

const GlobalSchema = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
  </Helmet>
);

export default GlobalSchema;
